import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types';
import type { Cohort } from '@efdigital/ll-addon-data/types/xceed/cohort';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import type { FindRecordOptions } from '@warp-drive/core/types/request';
import { findRecord, query } from '@warp-drive/utilities/json-api';

/**
 * Finds a cohort by id
 * @param cohortId - The id of the cohort to find
 * @returns JSON API request to find the cohort
 */
export function findCohort(cohortId: string) {
  return findRecord<Cohort>(DataTypeXceed.Cohort, cohortId, {
    ...jsonApiOptions,
    include: ['program', 'group', 'contacts', 'quizzes', 'certificates'],
  } as FindRecordOptions);
}

/**
 * Finds a cohort by id with its child content included
 * @param cohortId - The id of the cohort to find
 * @returns JSON API request to find the cohort with its child content included
 */
export function findCohortWithContent(cohortId: string) {
  return findRecord<Cohort>(DataTypeXceed.Cohort, cohortId, {
    ...jsonApiOptions,
    include: [
      'program',
      'pages',
      'modules',
      'quizzes',
      'certificates',
      'contacts',
      'group',
      'admingroup',
      'pages.calendarItems',
      'pages.calendarItems.contacts',
      'pages.readinglists',
      'pages.readinglists.resources',
    ],
  } as FindRecordOptions);
}

/**
 * Finds all cohorts by program id
 * @param programId - The program id that cohorts belong to
 * @returns JSON API request to find all cohorts by program id
 */
export function findCohortsByProgramId(programId: string) {
  return query<Cohort>(
    DataTypeXceed.Cohort,
    {
      'filter[program.id]': programId,
      'include[]': ['program', 'group', 'admingroup'],
    },
    jsonApiOptions
  );
}
